<template>
  <v-card>
    <v-card-title class="headline">일정 등록</v-card-title>
    <v-form v-model="valid" ref="form" @submit.prevent="onSubmit">
      <v-card-text>
        <v-select
          v-model="schData.planTyNo"
          :items="category"
          item-text="planTyNm"
          item-value="planTyNo"
          label="구분"
          @change="getCateVal"
        ></v-select>
        <template v-if="cateVal !== 404">
          <v-select
            v-model="schData.prjNo"
            :items="projectName"
            item-text="prjNm"
            item-value="prjNo"
            label="관련 프로젝트"
          ></v-select>
          <v-text-field
            v-model="schData.planTitle"
            :rules="[rules.required]"
            label="일정 제목"
          ></v-text-field>
          <v-select
            v-model="schData.empList"
            :items="employee"
            item-text="empNm"
            item-value="empNo"
            label="참여 직원"
            multiple
            clearable
            chips
            deletable-chips
          ></v-select>
        </template>
        <v-row>
          <v-col cols="11" sm="5">
            <v-menu
              ref="menuStart"
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="schData.startDt"
                  label="시작일"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="schData.startDt"
                no-title
                scrollable
                @input="saveStartPicker"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="11" sm="5">
            <v-text-field
              label
              v-model="schData.startTm"
              type="time"
              prepend-icon="mdi-alarm"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="11" sm="5">
            <v-menu
              ref="menuEnd"
              v-model="menuEnd"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="종료일"
                  v-model="schData.endDt"
                  :rules="[rules.diffTime]"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="schData.endDt"
                no-title
                scrollable
                :min="schData.startDt"
                @input="menuEnd = false"
                @change="dateValidate"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="11" sm="5">
            <v-text-field
              label
              v-model="schData.endTm"
              :rules="[rules.diffTime]"
              type="time"
              prepend-icon="mdi-alarm"
              @change="dateValidate"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-textarea
          v-model="schData.planText"
          rows="1"
          label="비고"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="onCancel">취소</v-btn>
        <v-btn type="submit" color="green darken-1" text>저장</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import { setPlan, modiPlan, planSelect } from "@/api/plan";

export default {
  data() {
    return {
      schData: {},
      valid: true,
      // titleRules: [value => !!value || "필수 항목입니다."],
      category: [],
      projectName: [],
      employee: [],
      menuStart: false,
      menuEnd: false,
      menuTimeStart: false,
      menuTimeEnd: false,
      cateVal: "",
      rules: {
        required: value => !!value || "필수 항목입니다.",
        diffTime: true,
      },
    };
  },
  props: ["isShow"],
  computed: {
    ...mapState("schedule", ["selScheduleData"]),
  },
  watch: {
    isShow(newVal) {
      if (!newVal) {
        this.reset();
      } else {
        this.schData = this.selScheduleData;
        this.$refs.form.resetValidation();
        this.loadSelect();
        this.getCateVal();
      }
    },
    // schData: {
    //   deep: true,
    //   handler(newVal) {
    //     newVal.startDt;
    //   },
    // },
  },
  created() {
    this.schData = this.selScheduleData;
  },
  mounted() {
    this.loadSelect();
    this.getCateVal();
  },
  methods: {
    ...mapActions("schedule", ["CREATE_SCHEDULE"]),
    getCateVal() {
      this.cateVal = this.schData.planTyNo;
    },
    reset() {
      setTimeout(() => {
        Object.assign(this.$data, this.$options.data());
      }, 100);
    },
    dateValidate() {
      // 종료일 validate
      if (!this.schData) return true;

      const startDiff = moment(
        `${this.schData.startDt} ${this.schData.startTm}`,
      );
      const endDiff = moment(`${this.schData.endDt} ${this.schData.endTm}`);
      const diffTime = endDiff.diff(startDiff, "minutes");

      this.rules.diffTime =
        diffTime > 0 || "종료일이 시작일보다 먼저일 수 없습니다.";
    },
    saveStartPicker() {
      // 시작일이 종료일보다 늦을 때 종료일 재설정
      const { startDt, endDt } = this.schData;
      const end = moment(endDt);
      const start = moment(startDt);
      const diff = moment.duration(end.diff(start)).asDays();

      // this.$refs.menuStart.save(this.schData.startDt);

      if (diff < 0) {
        this.schData.endDt = startDt;
      }

      this.menuStart = false;
    },
    startDtChange(date) {
      const end = moment(this.schData.endDt);
      const start = moment(date);
      const diff = moment.duration(end.diff(start)).asDays();

      if (diff < 0) {
        this.schData.endDt = date;
      }
    },
    async loadSelect() {
      try {
        const { data } = await planSelect("planTy,emp,prj");

        this.category = data.planTyList;
        this.employee = data.empList;
        this.projectName = data.prjList;
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    onCancel() {
      this.reset();
      this.$emit("hideModal");
    },
    async onSubmit() {
      this.$refs.form.validate();

      if (!this.valid) return false;

      const {
        planNo,
        planTyNo,
        prjNo,
        planTitle,
        startDt,
        startTm,
        endDt,
        endTm,
        empList,
        planText,
      } = this.schData;

      const startDate = moment(startDt).format("YYYYMMDD");
      const startTime = startTm.replace(":", "");
      const endDate = moment(endDt).format("YYYYMMDD");
      const endTime = endTm.replace(":", "");

      const newEmpList = !empList
        ? []
        : empList.map(v => {
            return { empNo: v };
          });

      const formData = {
        empList: newEmpList,
        prjNo: prjNo || "",
        planTyNo,
        planTitle,
        planText,
        planStDt: startDate,
        planStTm: startTime,
        planEdDt: endDate,
        planEdTm: endTime,
        emailSendYn: "N",
      };

      try {
        const { data } = !planNo
          ? await setPlan(formData)
          : await modiPlan(planNo, formData);

        if (data.ret < 0) {
          this.$emit("showAlert", "저장 실패");
        } else {
          this.$emit("showAlert", "저장되었습니다.");
        }
      } catch (error) {
        console.error(error.response.data.message);
      }

      this.$emit("hideModal");
    },
  },
};
</script>

<style scoped>
input[type="time"]::-webkit-calendar-picker-indicator {
  background: none;
}
</style>
